"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPlayer = _interopRequireDefault(require("react-player"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// TODO: bug the props dont seem to do anytning
var Video = function Video(_ref) {
  var url = _ref.url,
      height = _ref.height,
      width = _ref.width,
      controls = _ref.controls,
      playing = _ref.playing,
      loop = _ref.loop,
      light = _ref.light,
      playbackRate = _ref.playbackRate,
      playsinline = _ref.playsinline,
      pip = _ref.pip,
      rootClass = _ref.rootClass,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid;

  var styles = _Storyblok.default.anchorOrginToObj(rootClass);

  return /*#__PURE__*/_react.default.createElement(_reactPlayer.default, {
    url: url,
    height: height,
    width: width,
    controls: controls,
    playing: playing,
    loop: loop,
    light: light,
    playbackRate: playbackRate,
    playsinline: playsinline,
    pip: pip,
    style: _objectSpread({
      margin: '0'
    }, styles),
    className: storyblokClass,
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  });
};

var _default = Video;
exports.default = _default;
Video.propTypes = {
  /**
   * storyblok multiselect of css classes
  */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * The Url for the video.
   */
  url: _propTypes.default.string.isRequired,

  /**
   * height for the video .
   */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * width for the video.
   */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Set to true or false to display native player controls
   * Controls cannot be hidden for Wistia videos
   */
  controls: _propTypes.default.bool,

  /**
   * Set to true or false to pause or play the media.
   */
  playing: _propTypes.default.bool,

  /**
   * Set to true or false to loop the media.
   */
  loop: _propTypes.default.bool,

  /**
   * Set to true to show just the video thumbnail, which loads the full player on click
   * Pass in an image URL to override the preview image
   */
  light: _propTypes.default.bool,

  /**
   * Set the playback rate of the player
   * Only supported by YouTube, Wistia, and file paths
   */
  playbackRate: _propTypes.default.number,

  /**
   * Applies the playsinline attribute where supported.
   */
  playsinline: _propTypes.default.bool,

  /**
   * Set to true or false to enable or disable picture-in-picture mode
   * Only available when playing file URLs in certain browsers
   */
  pip: _propTypes.default.bool,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
Video.defaultProps = {
  height: '500px',
  width: '640px',
  controls: false,
  playing: false,
  loop: false,
  light: false,
  playbackRate: 1,
  playsinline: false,
  pip: false,
  rootClass: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};